import { connectCustom } from "@client/lib/misc";

import { type RootContainerProps } from "@client/content/types";
import { type AppState, Status } from "@client/types";
import { fetchPage } from "./actions";
import Component, { type ActionProps, type MapProps } from "./component";
import { localStateSelector, makeCategoryPageSizeSelector, makeGridListPropsSelector } from "./selectors";

const makeMapStateToProps = () => {
  const gridPropsSelector = makeGridListPropsSelector();
  const settingsSelector = makeCategoryPageSizeSelector();

  return (state: AppState, props: RootContainerProps): MapProps => {
    const localState = localStateSelector(state, props);
    const { categories, pageSize } = settingsSelector(state, props);

    return {
      ...props,
      gridProps: gridPropsSelector(state, props),
      categories,
      hasPosts: !!localState.items.length || localState.page > 1 || localState.status === Status.Loading,
      pageSize
    };
  };
};

const mapDispatchToProps = (dispatch: any, props: RootContainerProps): ActionProps => ({
  loadPage: (page: number) => dispatch(fetchPage({ id: props.id, source: props.source, page }))
});

export default connectCustom(makeMapStateToProps, mapDispatchToProps)(Component);
